import * as React from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import ZDRoute from "./zd10Seconds/route";
import DDRoute from "./ddAl/route";
import QM10Route from "./qm10Seconds/route";
import commonContext from "./common/context/common";
import { Utilities } from "./common/utils/utilities";
import { createBrowserHistory } from "history";
import { Zd10SecApis } from "./zd10Seconds/apis/zd10SecApis";
import { ALDDApis } from "./ddAl/apis/aLDDApis";
import { CommonApis } from "./common/apis/commonApis";
import CommonRoute from "./common/route";
import { Authorization } from "./common/utils/authorization";
import { Qm10SecApis } from "./qm10Seconds/apis/qm10SecApis";
import FintechRoute from "./fintech/route";

export type offerType = {
    customerName?: string;
    customerId?: string;
    promoCode?: string;
    product?: string;
    subProduct?: string;
    campaignId?: string;
    loanAvailed?: boolean;
    mobile?: string;
    createdOn?: string;
    email?: string;
    aadharNo?: string;
    pdApplicantFirstName?: string;
    pdApplicantLastName?: string;
    pdApplicantMiddleName?: string;
    pdPresentAddress1?: string;
    pdPresentAddress2?: string;
    pdPresentAddress3?: string;
    pdPresentCity?: string;
    pdPresentPin?: string;
    pdPresentState?: string;
    dob?: string;
    pdPanNo?: string;
    pdPresentLandMark?: string;
    edCompanyName?: string;
    edPresentAddress1?: string;
    edPresentAddress2?: string;
    edPresentAddress3?: string;
    edPresentCity?: string;
    edPresentLandMark?: string;
    edPresentPin?: string;
    edPresentState?: string;
    edPresentStd?: string;
    edPresentPhone?: string;
    salutation?: string;
    sex?: string;
    maritalStatus?: string;
    accountNo?: string;
    bankName?: string;
    bankAccount?: string;
    branch?: string;
    emi?: string;
    interestRate?: string;
    loanAmt?: string;
    processingFees?: string;
    tenure?: string;
    engineNumber?: string;
    chassisNumber?: string;
    registrationNumberVehicleNumber?: string;
    existingLoanAccountNumber?: string;
    modelDescription?: string;
    manufacturer?: string;
    lgCode?: string;
    smCode?: string;
    branchCode?: string;
    seCode?: string;
    customerRating?: string;
    customerCategory?: string;
    assetCost?: string;
    natureOfBusiness?: string;
    typeOfOffice?: string;
    typeOfIndustry?: string;
    typeOfCompany?: string;
    designation?: string;
    yearsInCurrentProfession?: string;
    totalWorkExperience?: string;
};

export type leadType = {
    promoCode: string;
    customerId: string;
    product: string;
    subProduct: string;
    campaignId: string;
    losAppId: string;
    leadId: string;
    mobile: string;
    otpAttemptsLeft?: number;
    otpAttemptsLeftText?: boolean;
    dealerSupplierId: string;
    roadTaxInsuranceAvailed: boolean;
    rtoEditAmount: string;
    rto: number;
    motorInsurancePremium: string;
    motorInsurancePremAmt: string;
    dealerInsuranceAvailed: boolean;
    dealerInsuranceAmt: string;
    motorInsuranceAvailed: boolean;
    dealerInsuranceAmtEdit: string;
    manufacturer: string;
    make: string;
    model: string;
    dealerAddress: string;
    VDOnRoadCost: string;
    interestRate: string;
    tenure: string;
    liTenure: number;
    insuranceAvailed: boolean;
    insuranceSsiPremium: string;
    processingFees: string;
    finalCarPrice: string;
    upto36m: string;
    M37_60: string;
    M61_84: string;
    loanAmt: string;
    desiredLoanAmount: string;
    stampDuty: string;
    desiredLoanAmountUpTo: string;
    liLoanAmount: string;
    insuranceNomineeName: string;
    insuranceNomineeRelation: string;
    totalLoanAmount: string;
    emi: string;
    marginMoneyPaid: string;
    totalAmount: string;
    LDIAgree: boolean;
    pdApplicantFirstName: string;
    pdApplicantMiddleName: string;
    pdApplicantLastName: string;
    pdPanNo: string;
    sex: string;
    maritalStatus: string;
    pdPresentAddress1: string;
    pdPresentAddress2: string;
    pdPresentAddress3: string;
    pdPresentCity: string;
    pdPresentPin: string;
    pdPresentState: string;
    state: string;
    city: string;
    pdPermState: string;
    pdPermAddress: string;
    pdPermAddress2: string;
    pdPermAddress3: string;
    pdPermCity: string;
    pdPermPinCode: string;
    dealerState: string;
    dealerCity: string;
    mfg: string;
    avgCost: number;
    otp: string;
    step: number;
    discountPrice: string;
    typeOfCustomer: string;
    email: string;
    edPresentPin: string;
    edPresentState: string;
    edPresentCity: string;
    edPresentAddress1: string;
    edPresentAddress2: string;
    edPresentAddress3: string;
    edCompanyName: string;
    edOfficeAddress: string;
    edOfficeAddress2: string;
    edOfficeAddress3: string;
    edOfficeCity: string;
    edOfficePinCode: string;
    edOfficeState: string;
    kycCompliantAgree: boolean;
    bankName: string;
    bankBranchName: string;
    bankAccount: string;
    img: string;
    temp?: string;
    bankNetBankingStatus?: boolean;
    bankDcStatus?: boolean;
    bankAadharStatus?: boolean;
    captchaInput: string;
    micrCode: string;
    accountType: string;
    ifsc: string;
    imps: Array<object>;
    uniqueReferenceNo: string;
    emandateChannel: string;
    eMandateUrn: string;
    secMandateUrn: string;
    emiStartDate: string;
    liInterestRate: string;
    liEMI: string;
    amountPayable: string;
    confirmStatus: boolean;
    dealers: Array<object>;
    existingLoanAccountNumber: string;
    modelDescription: string;
    chassisNumber: string;
    engineNumber: string;
    registrationNumberVehicleNumber: string;
    motorInsuranceQ1: string;
    motorInsuranceQ2: string;
    motorInsurancePremiumAmountY: string;
    motorInsurancePremiumAmountN: string;
    motorInsuranceClaimed: boolean;
    existingLoanAccount: string;
    shardKey: string;
    motorInsurancePremiumEditAmount: string;
    loadingBtn: string;
    edProfession: string;
    edIndustry: string;
    statesArray: Array<object>;
    citysList: any;
    collateralCharges: number;
    dealerName: string;
    loanAmtSelectedByUser: string;
};

interface IState {
    offer?: offerType;
    lead?: leadType;
    leadError?: object;
    token?: string;
}
interface IProps {}
export class App extends React.Component<IProps, IState> {
    authKeeper: Authorization = new Authorization();
    zdApi = new Zd10SecApis(
        process.env.NODE_ENV === "development"
            ? process.env.REACT_APP_ZD10SECOND_API
            : "",
        this.authKeeper
    );
    Qm10Api = new Qm10SecApis(
        process.env.NODE_ENV === "development"
            ? process.env.REACT_APP_QM10SECOND_API
            : "",
        this.authKeeper
    );
    ddApi = new ALDDApis(
        process.env.NODE_ENV === "development"
            ? process.env.REACT_APP_DDAL_API
            : "",
        this.authKeeper
    );
    commonAPI = new CommonApis(
        process.env.NODE_ENV === "development"
            ? process.env.REACT_APP_COMMON_API
            : "",
        this.authKeeper
    );
    constructor(props: IProps) {
        super(props);
        let defaultSSRProps = { $ssr: 1 };
        if (defaultSSRProps["error"]?.error) {
        }
        this.state = {
            offer: {
                // defaultSSR Props
                ...defaultSSRProps?.["result"]?.["offer"],
            },
            lead: {
                roadTaxInsuranceAvailed: true,
                motorInsuranceAvailed: true,
                dealerInsuranceAvailed: false,
                dealerInsuranceAmtEdit: "0",
                discountPrice: "0",
                insuranceAvailed: true,
                LDIAgree: false,
                natureOfRelation: "",
                otpAttemptsLeft: 3,
                otpAttemptsLeftText: false,
                kycCompliantAgree: false,
                step: 1,
                imps: [],
                ifsc: "",
                collateralCharges: 708,
                ...defaultSSRProps?.["result"]?.["lead"],
            },
            leadError: {},
            token: defaultSSRProps?.["result"]?.["token"],
        };
        if (this.state.token) {
            this.authKeeper.setAuthorization(this.state.token);
        }
    }
    render() {
        let contextValue = {
            history: createBrowserHistory(),
            utils: new Utilities(),
            lead: this.state.lead,
            offer: this.state.offer,
            commonAPI: this.commonAPI,
            setOffer: (data?: offerType) =>
                this.setState({ offer: { ...this.state.offer, ...data } }),
            setLead: (data?: leadType) =>
                this.setState({ lead: { ...this.state.lead, ...data } }),
            authKeeper: this.authKeeper,
            leadError: this.state.leadError,
            setLeadError: (data) =>
                this.setState({
                    leadError: { ...this.state.leadError, ...data },
                }),
        };
        return (
            <>
                <Router basename="/">
                    <Switch>
                        <Route path="/zd-10-seconds/">
                            <commonContext.Provider
                                value={{
                                    ...contextValue,
                                    apis: this.zdApi,
                                    base: "zd-10-seconds",
                                }}
                            >
                                <ZDRoute />
                            </commonContext.Provider>
                        </Route>
                        <Route path="/qm-10-seconds/">
                            <commonContext.Provider
                                value={{
                                    ...contextValue,
                                    apis: this.Qm10Api,
                                    base: "qm-10-seconds",
                                }}
                            >
                                <QM10Route />
                            </commonContext.Provider>
                        </Route>
                        <Route path="/dd-al/">
                            <commonContext.Provider
                                value={{
                                    ...contextValue,
                                    apis: this.ddApi,
                                    base: "dd-al",
                                }}
                            >
                                <DDRoute />
                            </commonContext.Provider>
                        </Route>
                        <Route path="/fintech/">
                            <commonContext.Provider
                                value={{
                                    ...contextValue,
                                    // apis: this.ddApi,
                                    base: "fintech",
                                }}
                            >
                                <FintechRoute />
                            </commonContext.Provider>
                        </Route>
                        <Route path="/common/">
                            <commonContext.Provider
                                value={{
                                    ...contextValue,
                                    apis: this.ddApi,
                                    base: "common",
                                }}
                            >
                                <CommonRoute />
                            </commonContext.Provider>
                        </Route>
                        <Route exact>
                            <h1>404 not Found</h1>
                        </Route>
                    </Switch>
                </Router>
                {/* <h1>dsfadsffasdf</h1> */}
            </>
        );
    }
}
